class ActiveController {
  constructor(){}

  /**
   *
   * @param uris
   * @returns {Array.<*>}
   */
  getTabsByUris( uris ){
    try{
      return Object.keys(uris).filter(key => {
        let uri     = uris[key],
            parts   = uri.split('/');
        if( !this.config.sub || this.config.sub.indexOf(parts[parts.length-1]) != -1 ){
          return parts[parts.length-1];
        }
      }).sort();
    } catch( e ){
      console.log( 'ActiveController > getTabsByUris > ' , e )
    }
  }

  /**
   *
   * @returns {*}
   */
  getTemplate(){
    return this.config.target;
  }

  /**
   *
   * @returns {string}
   */
  getSubName(){
    return this.config.target.toUpperCase();
  }

}

export default ActiveController;


/** WEBPACK FOOTER **
 ** ./frontend/@/controller.active.js
 **/